import { Button, Text } from "@chakra-ui/react"
import { FC } from "react"

import { ChatBubbleIcon } from "@/components/icons"
import Link from "@/components/RouteTransitionLink"
import { formatNumber } from "@/utils/formatNumber"

interface Props {
  className?: string
  commentCount?: number
  articleSlug?: string
  articlePathPrefix?: "/article" | "/case-study" | undefined
}

const PostCardCommentBtn: FC<Props> = ({
  articlePathPrefix = "/article",
  articleSlug = undefined,
  className = undefined,
  commentCount = 0,
}) => {
  return (
    <Link href={`${articlePathPrefix}/${articleSlug}#comments`}>
      <Button
        _active={{ transform: "translateY(0px)" }}
        _hover={{ transform: "translateY(-1px)" }}
        aria-label="Comments"
        borderLeft={"1px solid {colors.border}"}
        className={className}
        color="fg.muted"
        colorPalette="gray"
        gap="6px"
        height={"full"}
        minHeight={"64px"}
        px={3}
        py={1}
        rounded="0"
        size="lg"
        title="Comments"
        variant="ghost"
      >
        <ChatBubbleIcon boxSize="1.3em" />
        <Text>{formatNumber(commentCount)}</Text>
      </Button>
    </Link>
  )
}

export default PostCardCommentBtn
